import * as React from "react";
import $ from "jquery";
import { Link, useParams } from "react-router-dom";
import { Toast } from "bootstrap";
import { axiosInstance, axiosWithoutAuth } from "../../axios/axiosInstance";
import { useNoteAlert } from "../../Context/pleaseNote";
import { FORGORPASSWORD } from "../../constants";

export const ForgotPasswordMain = () => {
  const [txtEmaiAddress, settxtEmaiAddress] = React.useState("");
  const [txtLoginName, settxtLoginName] = React.useState("");
  const [errorText, seterrorText] = React.useState("");
  const { showNoteAlert } = useNoteAlert();

  const validateEmail = () => {
    var valEmail = document.getElementById("txtEmail").value;
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(valEmail)) {
      showNoteAlert(FORGORPASSWORD.INVALIDMAIL);
      return false;
    }
    // return true;

    //const mailFormat = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    ////var mailFormat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    //if (!valEmail.match(mailFormat)) {
    //    showNoteAlert(FORGORPASSWORD.INVALIDMAIL);
    //    return false;
    //}
  };

  const HideMultipleUserError = () => {
    $(".pwdError-toast").removeClass("show");
  };
  const SubmitClick = () => {
    //  document.getElementById("btnSubmit").disabled = true;
    var data = {
      txtUserMail: txtEmaiAddress,
      txtLoginName: txtLoginName,
    };
    if (txtEmaiAddress == "") {
      seterrorText("Please Enter Email Address");
      var focusID = document.getElementById("txtEmail");
      focusID.focus();
      //var toastEl = document.getElementById("emailErrorMsg");
      //var toastAdd = new Toast(toastEl);
      //toastAdd.show();
      showNoteAlert(FORGORPASSWORD.EMPTYMAIL);
      return false;
    } else {
      var ValidateEmail = validateEmail();
      if (ValidateEmail == false) {
        var focusID = document.getElementById("txtEmail");
        focusID.focus();
        return false;
      }
    }
    axiosInstance
      .post("ForgotPassword/ForgotPasswordEmailCheck", data)
      .then((response) => {
        if (response.data != "") {
          //document.getElementById("btnSubmit").disabled = false;
          if (response.data == "Multiple Users") {
            // document.getElementById("lblError").style.display = "block";
            document.getElementById("divMoreEmail").style.display = "block";
            //  document.getElementById("btnSubmit").style.display = "none";
            // document.getElementById("lblError").innerHTML = response.data;
            document.getElementById("divUpdateSuccess").style.display = "none";
          } else if (response.data != "sucess") {
            // document.getElementById("lblError").style.display = "block";
            showNoteAlert(response.data);
          } else {
            document.getElementById("divUpdateSuccess").style.display = "block";
            document.getElementById("divShowDetails").style.display = "none";

            //  document.getElementById("lblError").style.display = "none";
          }
          //setlbltotal(response.data.NetAmount);
          //setlbltax(response.data.TaxAmount);
          //setlblsubtotal(response.data.GrossAmount);
        }
      })
      .catch((error) => console.log(error.message));
  };

  return (
    <div className="loginWrapper-verification">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-lg-6 offset-md-2 offset-lg-3">
            <label id="lblError" style={{ fontSize: "14px", color: "red", display: "none" }} />
          </div>
        </div>
      </div>
      <div className="position-fixed bottom-0 end-0 p-3" style={{ zIndex: 99 }}>
        <div
          id="emailErrorMsg"
          className="toast hide"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          data-bs-delay={1000}
        >
          <div className="toast-body bg-black">
            <p className="text-uppercase text-white rounded-1">
              <i className="fa-solid fa-xmark" /> {errorText}
            </p>
          </div>
        </div>
      </div>

      <div className="container" id="divShowDetails" style={{ display: "block" }}>
        <div className="row">
          <div className="col-md-8 col-lg-6 offset-md-2 offset-lg-3">
            <div className="loginVerification-wrapper text-center">
              <div className="loginVerification-wrapperTitle">
                <h1 className="fw-semibold">Forgot Password</h1>
                <p className="fs-14 fw-normal">Enter your registered email to receive password reset instructions</p>
              </div>
              <form>
                <div className="row mt-4">
                  <div className="col-md-12">
                    <div className="floating-input floatingEmail-input mb-3">
                      <input
                        className="form-control form-input"
                        type="email"
                        id="txtEmail"
                        placeholder=""
                        required=""
                        value={txtEmaiAddress}
                        onChange={(changeEvent) => settxtEmaiAddress(changeEvent.target.value)}
                      />
                      <label for="txtEmail">Email</label>
                    </div>
                  </div>
                  <div id="divMoreEmail" style={{ display: "none" }}>
                    <div className="col-md-12">
                      <div className="floating-input floatingEmail-input">
                        <input
                          id="wesaccno"
                          className="form-control form-input"
                          type="text"
                          placeholder=""
                          required=""
                          value={txtLoginName}
                          onChange={(changeEvent) => settxtLoginName(changeEvent.target.value)}
                        />
                        <label for="wesaccno">Login Name or WES Account No</label>
                      </div>
                    </div>
                    <div className="col-md-12 mb-3">
                      <div
                        className="toast show pwdError-toast w-100 mt-3"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        <div className="toast-body fav-orderno-not d-flex align-content-center justify-content-between">
                          <div className="fav-ordernoNot-lft d-flex align-items-start justify-content-between">
                            <div>
                              <svg
                                width="47"
                                height="48"
                                viewBox="0 0 47 48"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect y="0.5" width="47" height="47" rx="23.5" fill="#F82643" fill-opacity="0.2"></rect>
                                <rect x="3" y="3.5" width="41" height="41" rx="20.5" fill="#F82643"></rect>
                                <path
                                  d="M23.5 21.375V25.75"
                                  stroke="white"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                                <path
                                  d="M23.5 32.2339H18.1975C15.1613 32.2339 13.8925 30.0639 15.3625 27.4126L18.0925 22.4951L20.665 17.8751C22.2225 15.0664 24.7775 15.0664 26.335 17.8751L28.9075 22.5039L31.6375 27.4214C33.1075 30.0726 31.83 32.2426 28.8025 32.2426H23.5V32.2339Z"
                                  stroke="white"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                                <path
                                  d="M23.4952 28.375H23.5031"
                                  stroke="white"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                            </div>
                            <div className="pwd-ordernoNot-info">
                              <h5 className="fw-semibold">Email Address is Assoicated to Multiple Users</h5>
                              <p className="fw-medium col-fs-13 fs-14 m-0">
                                Please Enter your unique user login name or WES Account No
                              </p>
                            </div>
                          </div>
                          <div className="ct-close">
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                              onClick={() => HideMultipleUserError()}
                            ></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 loginVerification-btn">
                    <div className="button-effect">
                      <a className="btn btn-products btn-addcart" data-bs-dismiss="modal" onClick={() => SubmitClick()}>
                        {" "}
                        Reset Password
                      </a>
                    </div>
                    <p className="mt-4">
                      Back to{" "}
                      <Link to="/Login" className="text-decoration-underline">
                        Login Screen
                      </Link>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="container" id="divUpdateSuccess" style={{ display: "none" }}>
        <div className="row">
          <div className="col-md-6 offset-md-3">
            <div className="loginVerification-wrapper text-center">
              <div className="loginVerification-wrapperTitle">
                <svg
                  width="100"
                  height="101"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="loginVerificationImg"
                >
                  <rect x="2" y="2.5" width="96" height="96" rx="48" fill="white" />
                  <rect
                    x="2"
                    y="2.5"
                    width="96"
                    height="96"
                    rx="48"
                    stroke="#3BA429"
                    strokeWidth="4"
                    className="drawRect"
                  />
                  <path
                    d="M62.5 71.75H37.5C30 71.75 25 68 25 59.25V41.75C25 33 30 29.25 37.5 29.25H62.5C70 29.25 75 33 75 41.75V59.25C75 68 70 71.75 62.5 71.75Z"
                    stroke="#3BA429"
                    strokeWidth="3.75"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="drawPath"
                  />
                  <path
                    d="M62.5 43L54.675 49.25C52.1 51.3 47.875 51.3 45.3 49.25L37.5 43"
                    stroke="#3BA429"
                    strokeWidth="3.75"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="drawPath"
                  />
                </svg>

                <h1 className="fw-semibold mt-4">Email Sent Successfully!</h1>
                <p className="fs-14 fw-normal">
                  If an account with this email address exists, you will receive an email from us shortly.
                </p>
                <div className="loginVerification-btn">
                  <p className="mt-4">
                    Back to{" "}
                    <Link to="/Login" className="text-decoration-underline">
                      Login Screen
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
